import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryBuilderHelper {
    constructor() { }

    //Method to remove all occurrences of ISNULL from string
    removeIsNullFromSQL(sql) {       
        const regex =/ISNULL\s*\(\s*([A-Za-z0-9_\.\[\]]+)\s*,\s*[^)]+\)\s*=\s*('[^']*'|\d+)/gi;

        return sql.replace(regex, (_match, columnName, value) => {
          return `${columnName} = ${value}`;
        });
  }

  updateConsentEmailAndConsentSMSFields(filter) {
  
    let value = filter;

    if (filter.includes("Consent_Email") || filter.includes("Consent_SMS")) {

      switch (filter) {
        case 'ISNULL(Consent_Email, \'\') != \'1\'':
          value = 'Consent_Email = 0'
          break;
        case 'ISNULL(Consent_Email, \'\') = \'1\'':
          value = 'Consent_Email is null or  Consent_Email = 1'
          break;
        case 'ISNULL(Consent_Email, \'\') != \'0\'':
          value = 'Consent_Email is null or  Consent_Email = 1'
          break;
        case 'ISNULL(Consent_Email, \'\') = \'0\'':
          value = 'Consent_Email = 0'
          break;
        case 'ISNULL(Consent_SMS, \'\') != \'1\'':
          value = 'Consent_SMS = 0'
          break;
        case 'ISNULL(Consent_SMS, \'\') = \'1\'':
          value = 'Consent_SMS is null or  Consent_SMS = 1'
          break;
        case 'ISNULL(Consent_SMS, \'\') != \'0\'':
          value = 'Consent_SMS is null or  Consent_SMS = 1'
          break;
        case 'ISNULL(Consent_SMS, \'\') = \'0\'':
          value = 'Consent_SMS = 0'
          break;
        default:
          value = filter;
      }
    }

    return value;
  }
}
